<template>
  <div class="content-wrapper settings-business">
    <div class="settings-business__wrapper">
      <div class="settings-business__box">
        <div class="settings-business__sign raleway raleway-bold">App Settings</div>
      </div>
    </div>
    <div class="tw:mt-6 main-contant-block">
      <ul class="nav-side-bar nav-bar-scroll">
        <li class="nav-side-bar__link">
          <router-link
            active-class="nav-side-bar__link--active"
            class="nav-side-bar__link"
            :to="{
              path: `${makeLinkToAnchorIntegrationSettings('general', this.$route.params.id)}`,
            }"
          >
            General Settings
          </router-link>
        </li>
        <li
          class="nav-side-bar__link"
          v-if="integration && allowedAccessStatuses.includes(integration.status)"
        >
          <router-link
            class="nav-side-bar__link"
            active-class="nav-side-bar__link--active"
            :to="{
              path: `${makeLinkToAnchorIntegrationSettings('members', this.$route.params.id)}`,
            }"
          >
            Members
          </router-link>
        </li>
        <li
          class="nav-side-bar__link"
          v-if="integration && allowedAccessStatuses.includes(integration.status)"
        >
          <router-link
            class="nav-side-bar__link"
            active-class="nav-side-bar__link--active"
            :to="{
              path: `${makeLinkToAnchorIntegrationSettings('webhooks', this.$route.params.id)}`,
            }"
          >
            Webhooks
          </router-link>
        </li>
        <li class="nav-side-bar__link">
          <router-link
            active-class="nav-side-bar__link--active"
            class="nav-side-bar__link"
            :to="{
              path: `${makeLinkToAnchorIntegrationSettings(
                'scanner-credential-fields',
                this.$route.params.id
              )}`,
            }"
          >
            Login workflow credentials
          </router-link>
        </li>
        <li class="nav-side-bar__link">
          <router-link
            active-class="nav-side-bar__link--active"
            class="nav-side-bar__link"
            :to="{
              path: `${makeLinkToAnchorIntegrationSettings(
                'compliance-scope',
                this.$route.params.id
              )}`,
            }"
          >
            Compliance Scope
          </router-link>
        </li>
      </ul>
      <router-view v-if="!showSpinner" />
      <Spinner v-if="showSpinner" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Spinner from '../Spinner';
import { makeLinkToAnchorIntegrationSettings } from '../../services/functions';
import { IntegrationStatusEnum } from '../../utils/constants/common';
import { trackAppSettingsOpened, trackAppSettingsSectionViewed } from '@/services/analytics';

export default {
  components: {
    Spinner,
  },
  data() {
    return {
      loaded: false,
      ENV: process.env.NODE_ENV,
      showSpinner: false,
      integrationId: null,
      allowedAccessStatuses: [
        IntegrationStatusEnum.ACTIVE,
        IntegrationStatusEnum.EXPIRED,
        IntegrationStatusEnum.TRIAL_REQUESTED,
        IntegrationStatusEnum.SAMPLE,
      ],
    };
  },
  async beforeMount() {
    this.showSpinner = true;
    this.integrationId = this.$route.params.id;
    await this.$store.dispatch('integrations/getIntegration', { id: this.integrationId });
    trackAppSettingsOpened(this.integrationId, this.integration?.integrationName);
    this.showSpinner = false;
  },
  watch: {
    '$route.path'(newPath) {
      const section = newPath.split('/').pop();
      if (section && this.integrationId) {
        trackAppSettingsSectionViewed(this.integrationId, this.integration?.integrationName, section);
      }
    },
  },
  methods: {
    makeLinkToAnchorIntegrationSettings,
  },
  computed: {
    ...mapGetters({
      integration: 'integrations/integration',
    }),
  },
};
</script>
<style lang="scss" scoped>
.settings-business {
  padding-top: 40px;
  background-color: #fafbfc;

  &__wrapper,
  &__box {
    display: flex;
    justify-content: space-between;
  }

  &__wrapper {
    &--left {
      justify-content: flex-start;
    }
  }

  &__sign {
    font-size: 36px;
    line-height: 120%;
    color: #242424;
  }
}

.nav-side-bar,
.nav-side-bar__link {
  font-size: 14px;
}

@media (max-width: 1000px) {
  .link-logout {
    margin-right: 20px;
  }

  .nav-side-bar {
    font-size: 14px;
    width: 100%;
  }
  .nav-bar-scroll {
    overflow: auto !important;
    padding-bottom: 10px !important;
  }
}
</style>
